import { jsx as p } from "react/jsx-runtime";
import { memo as E } from "react";
import { EDropzoneFileStatus as S } from "./types.mjs";
import { FileUploadStatus as j } from "./index61.mjs";
import { downloadFile as M, previewFile as P } from "./file.mjs";
import { isDefined as e } from "./types3.mjs";
import { useLocale as R } from "./useLocale.mjs";
import { FileListContainer as U } from "./styles41.mjs";
const I = E(
  ({
    files: l,
    fileStyle: c,
    onDelete: t,
    onDownload: n,
    onPreview: i,
    onReload: s,
    isDisabled: d,
    isDownloadable: u,
    isDeletable: F
  }) => {
    const f = R("dropzone");
    return /* @__PURE__ */ p(U, { children: l.map((o) => {
      const { name: h, percent: z, uid: m, status: a, originFile: r } = o, D = o.size || o.originFile?.size, w = o.error || f.defaultErrorMessage, g = () => e(t) && t(o), L = () => {
        e(n) ? n(o) : e(r) && M(r);
      }, v = () => {
        e(i) ? i(o) : e(r) && P(r);
      }, x = () => {
        e(s) && s(o);
      }, C = a === S.Done ? 100 : z;
      return /* @__PURE__ */ p(
        j,
        {
          name: h,
          percent: C,
          uid: m,
          error: w,
          onDelete: g,
          onDownload: L,
          isDownloadable: u,
          isDeletable: F,
          onPreview: v,
          onReload: x,
          status: a,
          isDisabled: d,
          size: D,
          fileStyle: c
        },
        m
      );
    }) });
  }
);
export {
  I as FileList
};
//# sourceMappingURL=index62.mjs.map
